import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home";
// import ProductListing from "./pages/ProductListing";
// import Product from "./pages/Product";
// import CartPage from "./pages/CartPage";
// import WishList from "./pages/WishList";
// import Checkout from "./pages/Checkout";
// import SuccessPage from "./pages/SuccessPage";
// import FailurePage from "./pages/FailurePage";
// import ProfileMenu from "./pages/ProfileMenu";
// import EditProfile from "./pages/EditProfile";
// import SavedAddresses from "./pages/SavedAddresses";
// import OrderListing from "./pages/OrderListing";
// import OrderDetail from "./pages/OrderDetail";
// import Accounts from "./pages/Accounts";
import ScrollToTop from "./components/ScrollTop";
// import { SnackyPop } from "./components/Snackbar";
import { Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "./store/store";
import { fetchSiteConfig } from "./store/siteConfigSlice";


const ProductListing = React.lazy(() => import("../src/pages/ProductListing"));
const Accounts = React.lazy(() => import("../src/pages/Accounts"));
const OrderDetail = React.lazy(() => import("../src/pages/OrderDetail"));
const Product = React.lazy(() => import("../src/pages/Product"));
const CartPage = React.lazy(() => import("../src/pages/CartPage"));
const Checkout = React.lazy(() => import("../src/pages/Checkout"));
const SuccessPage = React.lazy(() => import("../src/pages/SuccessPage"));
 const FailurePage = React.lazy(() => import("../src/pages/FailurePage"));
 const ProfileMenu = React.lazy(() => import("../src/pages/ProfileMenu"));
 const EditProfile = React.lazy(() => import("../src/pages/EditProfile"));
 const SavedAddresses = React.lazy(() => import("../src/pages/SavedAddresses"));
 
 const App: React.FC = () => (

  <Router>
    <ScrollToTop />

    <div className="App">
      <Navbar />
      <div className="nav-bar-next-item">

        <Routes>
          {/* Home Route */}
          <Route path="/" element={<Home />} />

          {/* Products Route */}
          <Route path="/products/" element={ <Suspense fallback={<div>loading...</div>}><ProductListing /></Suspense>} />
          <Route path="/accounts/*" element={<Suspense fallback={<div>loading...</div>}><Accounts /></Suspense>} />
          <Route path="/accounts/orders/:id" element={<Suspense fallback={<div>loading...</div>}><OrderDetail /></Suspense>} />
          <Route path="/products/:id" element={<Suspense fallback={<div>loading...</div>}><Product /></Suspense>} />
          <Route path="/cart" element={<Suspense fallback={<div>loading...</div>}><CartPage /></Suspense>} />
          <Route path="/checkout" element={<Suspense fallback={<div>loading...</div>}><Checkout /></Suspense>} />
          <Route path="/success" element={<Suspense fallback={<div>loading...</div>}><SuccessPage /></Suspense>} />
          <Route path="/failure" element={<Suspense fallback={<div>loading...</div>}><FailurePage /></Suspense>} />
          <Route path="/" element={<Suspense fallback={<div>loading...</div>}><ProfileMenu isLoggedIn={true} userName="John Doe" /></Suspense>} />
          <Route path="/edit-profile" element={<Suspense fallback={<div>loading...</div>}><EditProfile /></Suspense>} />
          <Route path="/saved-addresses" element={<Suspense fallback={<div>loading...</div>}><SavedAddresses /></Suspense>} />
        </Routes>
      </div>
      <Footer />
    </div>
  </Router>
);

export default App;

